import { render, staticRenderFns } from "./SelfServiceVettingRunner.vue?vue&type=template&id=27530a1c&scoped=true&"
import script from "./SelfServiceVettingRunner.vue?vue&type=script&lang=js&"
export * from "./SelfServiceVettingRunner.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceVettingRunner.vue?vue&type=style&index=0&id=27530a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27530a1c",
  null
  
)

export default component.exports